import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../locale/messages';

// Component
import CurrencyForm from '../CurrencyForm';
import { closeCurrencyModal } from '../../../../actions/siteadmin/modalActions';

import s from './CurrencyModal.css';

function CurrencyModal({ currencyModal, closeCurrencyModal }) {
  const initialValues = {
    isEnable: 1
  };

  return (
    <Modal
      show={currencyModal}
      onHide={closeCurrencyModal}
      dialogClassName='commonModalContainer'
    >
      <Modal.Header closeButton className='commonModalHeader'>
        <Modal.Title>
          <div className="commonModalTitle">
            <FormattedMessage {...messages.addCurrency} />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='commonModalBody'>
        <CurrencyForm initialValues={initialValues} />
      </Modal.Body>
    </Modal>
  );
}

const mapState = (state) => ({
  currencyModal: state.adminModalStatus.currencyModal,
});

const mapDispatch = {
  closeCurrencyModal,
};

export default withStyles(s)(connect(mapState, mapDispatch)(CurrencyModal));
